module.exports = __webpack_public_path__ + "img/this-is-a-wug-removebg-preview (1).e53d3a42.png";